import React, {Suspense, lazy} from 'react';
import { Switch, Route, Redirect, HashRouter } from 'react-router-dom';
import { getCookie } from "./util/cookie";
import '../styles/theme.less';
import '../styles/guidance.less'
import qs from "qs"
// import '../styles/App.less';
import { message } from 'antd';
import {all_login_ture } from "./util/keys"
import {CRM_USER_INFO} from "./util/keys";
import { GetQueryString } from './util/util'
const Main = lazy(()=>import('./containers/main'));
const login = lazy(()=>import('./containers/login'));
const all_login = lazy(()=>import('./containers/all_login'));
const PtLogin = lazy(()=>import('./containers/PtLogin'));
const checkLogin = lazy(()=>import('./containers/checkLogin'));
const noMatch = lazy(()=>import('./containers/noMatch'));
const HelpCenter = lazy(()=>import('./components/HelpCenter/HelpCenter'));

const HeatRace = lazy(()=>import('./components/HeatRace/HeatRace'));
const ssoLogin = lazy(()=>import('./components/Loading/Loading'));




message.config({
    maxCount: 3,
});

function App() {
    return (
        <HashRouter>
            {/*window.location.href.indexOf("3000") > 0 ||*/}
            <Suspense fallback={null}>
                {
                <Switch>
                    <Route exact path="/" render={() => <Redirect to="/main" replace />}/>
                    <PrivateRoute path="/main" title={"主页面"} component={ Main } />
                    <PrivateRoute exact path="/login"  title={"登录"} component={ login } />
                    <PrivateRoute exact path="/agent-login"  title={"登录"} component={ all_login } />
                    {/* 新代理商SSO登录 */}
                    <PrivateRoute exact path="/ssologin"  title={"登录"} component={ ssoLogin } />
                    {/* 入公校项目登录路由 */}
                    <PrivateRoute exact path="/pt-login" title="登录123" component={PtLogin} />
                    <PrivateRoute exact path="/checkLogin"  title={"登录"} component={ checkLogin } />
                    <PrivateRoute exact path="/404"  title={"404"} component={ noMatch } />
                    <PrivateRoute path="/HelpCenter"  title={"帮助中心"} component={ HelpCenter } />
                    <PrivateRoute path="/HeatRace"  title={"打地基热力赛"} component={ HeatRace } />
                    <PrivateRoute path="*" component={ noMatch } />
                </Switch>
                }
            </Suspense>
        </HashRouter>
    );
}

function PrivateRoute({
    component: Component,
    ...rest
}) {
    let token = getCookie('CRM_TOKEN'),
        toLogin = false, // 跳转登录页
        toSsoLogin = false // sso 自动登录

        // /pt-login 为入公校项目登录路由
    if(window.location.href.indexOf("dev-agent")  > 0|| window.location.href.indexOf("test-agent") > 0 || window.location.href.indexOf("agent") > 0 ){
        localStorage.setItem(all_login_ture,'1');
    }
    else {
        localStorage.setItem(all_login_ture,'2');
    }

    // return
    if (rest.path === '/login' || rest.path === '/pt-login' || rest.path === '/agent-login' || rest.path === '/ssologin') {
        toLogin = false
        toSsoLogin = false
    } else if (rest.path !== '/404' && rest.path !== '/checkLogin') {
        const hash = window.location.hash
        const search = qs.parse(decodeURIComponent(hash).split("?")[1] || "") || {}
        // if (search.nw && ((hash.indexOf("#/main/ReportNav/ReportManage") >= 0) || (hash.indexOf("#/main/supervise") >= 0))) {
        if (search.nw && ((/#\/main\/ReportNav\/ReportManage|#\/main\/supervise|#\/main\/FeedbackDetails/).test(hash))) {
            toLogin = false
            toSsoLogin = false
        } else {
            toLogin = !token
        }
    } else if(rest.path === '/ssologin'){
        
    }
    // window.location.href.indexOf("3000") > 0 ||
    document.title = rest.title ? `智能硬件代理商管理系统-${rest.title}` : '智能硬件代理商管理系统'

    if(GetQueryString().ssoToken){
        toSsoLogin = true
        localStorage.setItem('needBackSso',1)
    }

    return (    
        <Route
            {...rest}
            render={ props => toLogin ? (
                <Redirect
                    to={{
                        pathname: toSsoLogin ? '/ssologin':"/login",
                        state: { from: props.location }
                    }}
                />
            ): (
                <Component {...props} />
            )
            }
        />
    )

}
export default App;
